import { useSyncExternalStore } from 'react'

const KEY = 'safeward-ui.privacy.v1'
const CLASS = 'privacy-on'

let enabled: boolean = (() => {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
})()

const listeners = new Set<() => void>()

if (typeof document !== 'undefined' && document.body) {
  document.body.classList.toggle(CLASS, enabled)
}

export function getPrivacy(): boolean {
  return enabled
}

export function setPrivacy(next: boolean): void {
  if (enabled === next) return
  enabled = next
  try {
    localStorage.setItem(KEY, next ? '1' : '0')
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.toggle(CLASS, next)
  }
  listeners.forEach((l) => l())
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

export function usePrivacy(): boolean {
  return useSyncExternalStore(subscribe, getPrivacy, getPrivacy)
}

/**
 * Asterisk-mask an address or 0x-prefixed hex string. Keeps the `0x`
 * prefix so renders still look hex-shaped during a screencast.
 */
export function maskAddress(addr: string): string {
  if (!addr) return addr
  return addr.startsWith('0x') ? '0x****…****' : '****…****'
}
